import React from "react";
import { workheaderData } from "../../utils/Dummy";

function WorkHeader({ selected, setSelected }) {
  return (
    <section className="flex flex-col">
      <div className="flex mt-5 " data-aos="fade-right" data-aos-delay="500">
        {workheaderData.map((item, index) => (
          <button
            key={index}
            className={
              selected === item.name
                ? "me-4 text-sky-500 font-semibold text-sm"
                : "me-4 text-gray-400 font-semibold text-sm"
            }
            onClick={() => setSelected(item.name)}
          >
            {item.name}
          </button>
        ))}
      </div>
    </section>
  );
}

export default WorkHeader;
